interface User {
    id?: string;
    email?: string;
    address?: string | null;
    firstName?: string;
    lastName?: string;
    profilePic?: string;
    phoneNumber?: string;
    ref?: string;
    location?: {
        street: string
        additional?: string,
        zipcode: string,
        city: string,
        country: string
    };
    hasHandicapCard?: boolean;
    language?: string;
    birthdate?: Date;
    hasConsented?: boolean;
}

export type { User as default };

// Auth state
interface AuthState {
    user: User | null;
    isAuthenticated: boolean;
    token: string | null;
}

export type { AuthState };

// Validation functions
export const isValidEmail = (email: string): boolean => /^[^\s@]+@[^\s@.]+\.[^\s@]+$/.test(email);
export const isValidPassword = (password: string): boolean => password.length > 6;

export const validateNewPassword = (value: string): boolean => {
    if (value == null || value == '') {
        throw new Error('pwdEmpty');
    }
    if (value.length < 8) {
        throw new Error('pwdTooShort');
    }
    if (/\s/.test(value)) {
        throw new Error('pwdContainsSpaces');
    }
    if (!/[A-Z]/.test(value)) {
        throw new Error('pwdNoUpperCase');
    }
    if (!/[a-z]/.test(value)) {
        throw new Error('pwdNoLowerCase');
    }
    if (!/\d/.test(value)) {
        throw new Error('pwdNoNb');
    }
    if (!/[^A-Za-z0-9]/.test(value)) {
        throw new Error('pwdNoSpecialChar');
    }
    return true;
};
